import { render } from "./ConversationViewer.vue?vue&type=template&id=770bc6fe&scoped=true"
import script from "./ConversationViewer.vue?vue&type=script&lang=js"
export * from "./ConversationViewer.vue?vue&type=script&lang=js"

import "./ConversationViewer.vue?vue&type=style&index=0&id=770bc6fe&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770bc6fe"]])

export default __exports__